export default __webpack_public_path__ + "static/media/M1A_4.57c4b081.png";